export const toUTC = (date, time) => {
  const local = new Date(`${date}T${time}:00`);
  return new Date(local.getTime() - (2 * 60 * 60 * 1000)).toISOString();
};

 export const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  export const formatHoursAndMinutes = (decimalHours) => {
  if (!decimalHours || decimalHours <= 0) return "0m 0h";

  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);

  return `${hours>9?hours:`${hours}`}h   ${minutes>9?minutes:`0${minutes}`}m`;
};
